import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import ResponseError from "#/types/responseError"
import type { ContentMemberContext } from "./types"

export function useMemberContext(enabled: boolean): UseQueryResult<ContentMemberContext, ResponseError> {
  return useQuery<ContentMemberContext, ResponseError>({
    queryKey: ["member-context"],
    queryFn: () => carrotClient.getMemberContext(),
    enabled,
    refetchOnWindowFocus: false,
    retry: buildCarrotApiRetryPolicy(3),
    staleTime: 0
  })
}
